/**
 * Shorthands the inline-styled pages use for the brand palette.
 *
 * These pages and their siblings are ports of the InsuCoach design and style
 * everything inline, so each of them had grown its own copy of the same aliases
 * (`BRAND`, `TEXT_1`, `CARD_BG`, …). Only names that held an identical value in every
 * page live here; where a page genuinely needs a different shade it keeps a local
 * constant with a page-specific name instead of quietly redefining a shared one.
 *
 * @module @shared/constants
 */

import { brandColors, brandRgba, brandShadowRgba } from './brand-colors';

/* Brand */
export const BRAND = brandColors.brandPrimary;
export const BRAND_2 = brandColors.brandPrimaryAlt;
export const G_START = brandColors.brandPrimary;
export const G_END = brandColors.brandPrimaryAlt;
export const PURPLE = brandColors.accentUnique;

/* Status */
export const SUCCESS = brandColors.success;
export const SUCCESS_C = brandColors.success;
export const WARNING = brandColors.warning;
export const WARNING_C = brandColors.warning;
export const DANGER = brandColors.danger;
export const DANGER_C = brandColors.danger;

/* Text */
export const TEXT_1 = brandColors.textPrimary;
export const TEXT_2 = brandColors.textSecondary;
export const TEXT_3 = brandColors.textTertiary;
export const TEXT_PRIMARY = brandColors.textPrimary;
export const TEXT_SECONDARY = brandColors.textSecondary;
export const TEXT_TERTIARY = brandColors.textTertiary;

/* Surfaces */
export const WHITE = brandColors.surfaceCard;
export const CANVAS = brandColors.canvas;
export const CARD_BG = brandRgba('surfaceCard', 0.96);
export const GLASS_BG = brandRgba('surfaceCard', 0.85);
export const GLASS_1 = brandRgba('surfaceCard', 0.66);
export const TINT_BLUE = brandRgba('brandPrimary', 0.1);
export const TINT_GREEN = brandRgba('success', 0.1);

/* Shadows */
export const GLASS_SHADOW = `0 2px 8px ${brandShadowRgba('textPrimary', 0.1)}, 0 1px 2px ${brandShadowRgba('textPrimary', 0.06)}, inset 0 1px 0 ${brandShadowRgba('surfaceCard', 0.6)}`;
